<template>
  <div class="mb-3">
    <component
        v-if="objectTypeHasComponent"
        :is="attachmentObjectType"
        :details="attachment.details"
        :label="label"
    />
    <div v-else>
      <p>{{ label }} <strong>{{ humanizedObjectType }}</strong></p>
      <ul class="list-unstyled object-details">
        <li>No further details are available.</li>
      </ul>
    </div>
  </div>
</template>

<script>
import aFormSubmission from './details/aFormSubmission.vue';
import EpicInbasketMessage from './details/EpicInbasketMessage.vue';
import EventBlock from './details/EventBlock.vue';
import FeedbackEvent from './details/FeedbackEvent.vue';
import MessagingTrigger from './details/MessagingTrigger.vue';
import Payment from './details/Payment.vue';
import Source from './details/Source.vue';
import StudyUserConversation from "./details/StudyUserConversation.vue";
import StudyUserEventBlock from './details/StudyUserEventBlock.vue';
import StudyUserSchedule from './details/StudyUserSchedule.vue';
import TextMessage from './details/TextMessage.vue';
import Transaction from './details/Transaction.vue';
import Variable from './details/Variable.vue'

export default {
  components: {
    aFormSubmission,
    EpicInbasketMessage,
    EventBlock,
    FeedbackEvent,
    MessagingTrigger,
    Payment,
    Source,
    StudyUserConversation,
    StudyUserSchedule,
    StudyUserEventBlock,
    TextMessage,
    Transaction,
    Variable,
  },
  props: {
    attachment: {
      type: Object,
      default: function () {
        return {};
      }
    },
    label: {
      type: String,
      default: "Related to"
    }
  },
  computed: {
    attachmentObjectType() {
      if (this.attachment.object_type.includes('MessagingTrigger')) {
        return 'MessagingTrigger';
      }

      if (this.attachment.object_type.endsWith('Variable')) {
        return 'Variable';
      }

      if (this.attachment.object_type !== 'StudyUserEventBlock' && this.attachment.object_type.endsWith('EventBlock')) {
        return 'EventBlock';
      }

      if (['UserEvent','UserEnrollmentStep'].includes(this.attachment.object_type)) {
        return 'FeedbackEvent';
      }

      return this.attachment.object_type;
    },
    objectTypeHasComponent() {
      return Object.keys(this.$options.components).includes(this.attachmentObjectType);
    },
    humanizedObjectType() {
      return this.attachment.object_type.replace(/([A-Z])/g, ' $1');
    }
  },
  name: "Details"
}
</script>

<style scoped>
  >>> .object-details {
    padding-left: 10px;
    margin-left: 20px;
    border-left: 3px solid #dee2e6;
    margin-bottom: 1rem;
  }
</style>